import React from 'react'
import CreatableSelect from 'react-select/creatable'
import API from 'common/logic/API'
import { Tag } from 'types'

interface Option {
    value: number | string
    label: string
    __isNew__?: boolean
}

interface Props {
    selectedTagIds: number[]
    availableTags: Tag[]
    onChange: (tagIds: number[], updatedTags: Tag[]) => void
    isDisabled?: boolean
}

function TagSelect({ selectedTagIds, availableTags, onChange, isDisabled }: Props) {
    const options: Option[] = availableTags.map(t => ({ value: t.id, label: t.name }))

    const selectedOptions: Option[] = selectedTagIds
        .map(id => availableTags.find(t => t.id === id))
        .filter((t): t is Tag => t !== undefined)
        .map(t => ({ value: t.id, label: t.name }))

    const handleChange = (selected: readonly Option[]) => {
        onChange(
            selected.filter(o => !o.__isNew__).map(o => o.value as number),
            availableTags
        )
    }

    const handleCreate = (inputValue: string) => {
        API.post('/tags', { name: inputValue })
            .then((response: any) => {
                const newTag: Tag = response.data
                const updatedTags = [...availableTags, newTag]
                const newIds = [...selectedTagIds, newTag.id]
                onChange(newIds, updatedTags)
            })
            .catch(() => {
                // creation failed — ignore silently
            })
    }

    return (
        <CreatableSelect
            classNamePrefix="tag-select"
            isMulti
            isClearable
            isDisabled={isDisabled}
            options={options}
            value={selectedOptions}
            onChange={handleChange as any}
            onCreateOption={handleCreate}
            placeholder="Select or create tags..."
            formatCreateLabel={(input: string) => `Create tag "${input}"`}
            styles={{
                control: (base: any) => ({
                    ...base,
                    minHeight: '38px',
                }),
            }}
        />
    )
}

export default TagSelect
